export default __webpack_public_path__ + "static/media/steps-cover-9.9e761eba.png";